/**
 * Returns the appropriate symbol or prefix for a given currency code.
 */
export const getCurrencySymbol = (currency?: string): string => {
  if (!currency) return "₦";
  const normalized = currency.trim().toUpperCase();
  switch (normalized) {
    case "NGN":
      return "₦";
    case "USD":
      return "$";
    case "GBP":
      return "£";
    case "EUR":
      return "€";
    case "KES":
      return "KES ";
    case "USDT":
      return "USDT ";
    case "USDC":
      return "USDC ";
    default:
      return `${normalized} `;
  }
};

export interface FormatCurrencyOptions {
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  fallback?: string;
}

/**
 * Formats a monetary amount dynamically with the active currency symbol
 * and localized comma separation. Abolishes static mock figures by falling
 * back strictly to the formatted zero value or designated fallback string.
 *
 * @param amount - The numerical amount to format
 * @param currency - The active currency code (e.g. "NGN", "USD", "GBP", "EUR")
 * @param options - Custom decimal limits and fallback overrides
 */
export const formatCurrencyAmount = (
  amount: number | string | undefined | null,
  currency: string = "NGN",
  options?: FormatCurrencyOptions
): string => {
  if (
    amount === undefined ||
    amount === null ||
    amount === "" ||
    isNaN(Number(amount))
  ) {
    return options?.fallback ?? `${getCurrencySymbol(currency)}0.00`;
  }

  const num = Number(amount);
  const symbol = getCurrencySymbol(currency);
  const formatted = num.toLocaleString("en-US", {
    minimumFractionDigits: options?.minimumFractionDigits ?? 2,
    maximumFractionDigits: options?.maximumFractionDigits ?? 2,
  });

  return `${symbol} ${formatted}`;
};
